import { request } from '../../helpers/api/request';
import { CreateFaqContract, CreateFaqModel } from '../../types/Endpoints/faq/FaqContracts';

export const createFaq = async (requestData: CreateFaqModel) => {
    const { data } = await request<CreateFaqContract>({
        url: 'admin/faq',
        method: 'POST',
        data: requestData,
    });

    return data;
};
